import { JoinData } from './JoinDataInt';

const videoBlockHeight = 362;
const videoBlockWidth = 359;

const videoNameHeight = 26;
const videoNameY = 219;

const goToButtonWidth = 40;
const goToButtonHeight = 34;
const goToButtonY = 214;

const selectSourceWidth = 160;
const selectSourceHeight = 52;

const sourceTextWidth = 265;
const sourceTextHeight = 30;

const offMutedWidth = 158;
const offMutedHeight = 54;
const offMutedY = 491;

const volumeButtonWidth = 43;
const volumeButtonHeight = 43;
const volumeButtonY = 426;

const category = "global_video";

const globalVideo: JoinData[] = [
    { join: "digital-press-504", name: "Back", x: 129, y: 32, width: 53, height: 36, category },

    { join: 'digital-feedback-544', name: "Home Video Off Visibility", x: 224, y: 25, width: 149, height: 56, category },
    { join: 'digital-press-542', name: "Home Video Off", x: 224, y: 25, width: 149, height: 56, category },
    { join: 'digital-feedback-543', name: "Floor Video Off Visibility", x: 1081, y: 22, width: 145, height: 63, category },
    { join: 'digital-press-541', name: "Floor Video Off", x: 1081, y: 22, width: 145, height: 63, category },

    { join: 'digital-feedback-GlobalSystems.Video.Video.List_Item1_Visible.Visibility', name: "Video Zone 1 Visibility", x: 128, y: 202, width: videoBlockWidth, height: videoBlockHeight, category },
    { join: 'serial-feedback-GlobalSystems.Video.Items[0].Name.Indirect', name: "Video Zone 1 Name", x: 144, y: videoNameY, width: 72, height: videoNameHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[0].Controls.Press', name: "Go to Video Zone 1 (Disabled Unless Zone Is On)", x: 424, y: goToButtonY, width: goToButtonWidth, height: goToButtonHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[0].SourceSelect.Selected_fb', name: "Video Zone 1 Select Source Feedback", x: 227, y: 302, width: selectSourceWidth, height: selectSourceHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[0].SourceSelect.Press', name: "Video Zone 1 Select Source", x: 227, y: 302, width: selectSourceWidth, height: selectSourceHeight, category },
    { join: 'serial-feedback-GlobalSystems.Video.Items[0].CurrentSource.Indirect', name: "Video Zone 1 Selected Source", x: 240, y: 318, width: 115, height: 20, colour: "#000000", category },
    { join: 'serial-feedback-GlobalSystems.Video.Items[0].CurrentSource.Indirect', name: "Video Zone 1 Selected Source Name", x: 175, y: 368, width: sourceTextWidth, height: sourceTextHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[0].Off.Selected_fb', name: "Video Zone 1 Off Feedback", x: 154, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[0].Off.Press', name: "Video Zone 1 Off", x: 154, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[0].Mute.Selected_fb', name: "Video Zone 1 Mute Feedback", x: 317, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[0].Mute.Press', name: "Video Zone 1 Mute", x: 317, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    {
        join: 'analog-feedback-GlobalSystems.Video.Items[0].Volume.LowerTouchfb_fb',
        name: "Video Zone 1 Current Volume", x: 285, y: volumeButtonY, width: volumeButtonWidth, height: volumeButtonHeight,
        category, group: "volume_0"
    },
    {
        join: 'digital-feedback-GlobalSystems.Video.Items[0].GlobalVideoRefCONTRACT.Volume.Visibility_fb',
        name: "Video Zone Volume Visibility", x: 285, y: volumeButtonY, width: volumeButtonWidth, height: volumeButtonHeight,
        category, group: "volume_0"
    },

    { join: 'digital-feedback-GlobalSystems.Video.Video.List_Item3_Visible.Visibility', name: "Video Zone 3 Visibility", x: 864, y: 202, width: videoBlockWidth, height: videoBlockHeight, category },
    { join: 'serial-feedback-GlobalSystems.Video.Items[2].Name.Indirect', name: "Video Zone 3 Name", x: 879, y: videoNameY, width: 120, height: videoNameHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[2].Controls.Press', name: "Go to Video Zone 3 (Disabled Unless Zone Is On)", x: 1161, y: goToButtonY, width: goToButtonWidth, height: goToButtonHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[2].SourceSelect.Selected_fb', name: "Video Zone 3 Select Source Feedback", x: 963, y: 302, width: selectSourceWidth, height: selectSourceHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[2].SourceSelect.Press', name: "Video Zone 3 Select Source", x: 963, y: 302, width: selectSourceWidth, height: selectSourceHeight, category },
    { join: 'serial-feedback-GlobalSystems.Video.Items[2].CurrentSource.Indirect', name: "Video Zone 3 Selected Source", x: 1005, y: 318, width: 60, height: 20, colour: "#000000", category },
    { join: 'serial-feedback-GlobalSystems.Video.Items[2].CurrentSource.Indirect', name: "Video Zone 3 Selected Source Name", x: 985, y: 368, width: sourceTextWidth - 150, height: sourceTextHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[2].Off.Selected_fb', name: "Video Zone 3 Off Feedback", x: 890, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[2].Off.Press', name: "Video Zone 3 Off", x: 890, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[2].Mute.Selected_fb', name: "Video Zone 3 Mute Feedback", x: 1053, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    { join: 'digital-press-GlobalSystems.Video.Items[2].Mute.Press', name: "Video Zone 3 Mute", x: 1053, y: offMutedY, width: offMutedWidth, height: offMutedHeight, category },
    {
        join: 'analog-feedback-GlobalSystems.Video.Items[2].Volume.LowerTouchfb_fb',
        name: "Video Zone 3 Current Volume", x: 1022, y: volumeButtonY, width: volumeButtonWidth, height: volumeButtonHeight,
        category, group: "volume_2"
    },
    {
        join: 'digital-feedback-GlobalSystems.Video.Items[2].GlobalVideoRefCONTRACT.Volume.Visibility_fb',
        name: "Video Zone Volume Visibility", x: 1022, y: volumeButtonY, width: volumeButtonWidth, height: volumeButtonHeight,
        category, group: "volume_2"
    },
];

export default globalVideo;
